import { keys } from 'ldash';
export const mergeI18nLayers = (base = {}, domain = {})=>{
    let merged = {};
    let languages = new Set([
        ...keys(base),
        ...keys(domain)
    ]);
    languages.forEach((language)=>{
        merged[language] = {
            ...base[language] || {},
            ...domain[language] || {}
        };
    });
    return merged;
};
